<div style="min-height: 100%">
  <div class="loading"></div>
</div>
